<script>
export let src;
export let poster;
export let size = 240;
export let autoplay = undefined;
let videoPlayer;
function mouseOver() {
    if (autoplay) {
        return;
    }
    videoPlayer.play();
}
function mouseOut() {
    if (autoplay) {
        return;
    }
    videoPlayer.currentTime = 0;
    videoPlayer.pause();
}
function tap() {
    if (autoplay) {
        return;
    }
    videoPlayer.play();
}
</script>

<video poster="{poster}" playsinline="true" autoplay="{autoplay}" src="{src}" bind:this={videoPlayer} on:touchstart={tap} on:mouseout={mouseOut} on:mouseover={mouseOver} width="{size}" height="{size}" volume="0" loop="loop">
    <track kind="captions" />
</video>